(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-content"] && !Shopify.designMode) return;
  try {
    
  class MarqueeText extends HTMLElement {
    connectedCallback() {
      if (this._mounted) return;
      this._mounted = true;

      this._track = this.querySelector('.scrolling-content__track');
      if (!this._track) return;
      this._originals = Array.from(this._track.children);
      if (this._originals.length === 0) return;

      this._track.style.animationDirection = this.getAttribute('direction') === 'right' ? 'reverse' : 'normal';

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this._build(), { once: true });
      } else {
        this._build();
      }

      this._resizeObserver = new ResizeObserver(() => this._updateDuration());
      this._resizeObserver.observe(this);
    }

    disconnectedCallback() {
      this._resizeObserver?.disconnect();
    }

    _build() {
      const track = this._track;
      const containerWidth = this.clientWidth;
      if (containerWidth === 0) {
        requestAnimationFrame(() => this._build());
        return;
      }

      const widthOf = (el) => {
        const mie = parseFloat(getComputedStyle(el).marginInlineEnd) || 0;
        return el.offsetWidth + mie;
      };
      const originalSetWidth = this._originals.reduce((sum, el) => sum + widthOf(el), 0);
      if (originalSetWidth === 0) return;

      let setWidth = originalSetWidth;
      while (setWidth < containerWidth) {
        this._originals.forEach((el) => track.appendChild(el.cloneNode(true)));
        setWidth += originalSetWidth;
      }

      Array.from(track.children).forEach((el) => {
        const clone = el.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });

      this._setWidth = setWidth;
      this._updateDuration();
    }

    _updateDuration() {
      if (!this._track || !this._setWidth) return;
      const speed = parseFloat(this.getAttribute('speed')) || 0.3;
      const duration = (1 / speed) * (this._setWidth / 300);
      this._track.style.animationDuration = `${duration}s`;
    }
  }

  if (!customElements.get('marquee-text')) {
    customElements.define('marquee-text', MarqueeText);
  }

  } catch(e) { console.error(e); }
})();
})();
